import { Box, Button, Paper, Popper, styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const Content = styled('div')(() => ({
  minHeight: '2.75rem',
  borderRadius: '0.5rem',
  width: '100%',
  cursor: 'pointer',
  [theme.breakpoints.up('md')]: {
    width: '11.25rem',
  },
  alignItems: 'center',
  backgroundColor: theme.palette.primary.light,
  display: 'flex',
  justifyContent: 'center',
  gap: '0.5rem',
  '&.active': {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.common.white,
    border: `1px solid ${theme.palette.primary.dark}`,
  },
}));

export const MarginContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-evenly',
  marginTop: '0.20rem',
}));

export const StyledPopper = styled(Popper)(() => ({
  zIndex: 10,
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: '1.5rem',
  width: '18.75rem',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
}));

export const ActionsBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  gap: 8,
});

export const DateBox = styled(Box)(() => ({
  marginBottom: '0.5rem',
  marginTop: '0.25rem',
}));

export const StyledActionButton = styled(Button)(() => ({
  borderRadius: '2.5rem',
  marginTop: '1.5rem',
  textTransform: 'none',
  fontWeight: '700',
}));

export const TitleContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  width: '100%',
}));
